module.exports = __webpack_public_path__ + "static/img/xiaolaba.a5ad517e.png";